import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import Payment from "../../payment/types/Payment";

type Output = Payment[];

export default function useBookingPaymentsGet(
    bookingInternalId: any,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    return useCacheQuery<Output>(
    ["booking-payments", bookingInternalId],
    () => {
      // Add default filters: request up to 500 items and only paid payments
      return client.get<any>(`bookings/` + bookingInternalId + `/payments`, {
        itemsPerPage: 500,
        paid: true,
      });
    },
    options
  );
}

